<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper register-surv">
    <div class="container-fluid">
      <div class="login-wrapper">
        <div class="login-inbox">
          <div class="log-auth">
            <div class="login-auth-wrap">
              <div class="login-content-head">
                <h3>Forgot Password</h3>

                <p v-if="message" class="text-success">{{message}}</p>
                <p v-else>Enter your email and we will send you a reset password link to reset your password.</p>

                <p v-if="error" class="text-danger">{{ error }}</p>
              </div>
            </div>
            <form>
              <div class="form-group">
                <label class="form-label">Email <span>*</span></label>
                <input
                  v-model="email"
                  class="form-control form-control-lg group_formcontrol"
                  id="email"
                  name="email"
                  type="text"
                  placeholder="Your e-mail"
                />
              </div>

              <button
                class="btn btn-primary w-100 btn-size justify-content-center"
                @click.prevent="getResetPasswordLink"
              >
                Get Link
              </button>

              <router-link
                to="/login"
                class="btn btn-secondary w-100 btn-size justify-content-center mt-2"
              >Login
              </router-link>

              <div class="bottom-text text-center mt-2">
                <p>
                  <a :href="websiteUrl">Go to Website</a>
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Main Wrapper -->
</template>

<script>
import config from "@/config.js";

export default {
  computed: {
    websiteUrl() {
      return config.WEBSITE_URL;
    },
  },

  data() {
    return {
      email: '',
      message: '',
      error: '',
    };
  },

  methods: {
    async getResetPasswordLink() {
      const r = await this.$store.dispatch('auth/getResetPasswordLink', this.email);

      if (r.success) {
        this.message = 'Reset password link sent successfully';

        this.email = '';
      } else {
        this.error = 'Something went wrong. Please try again in a few moments.';
      }
    },
  },
};
</script>
